
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DocumentTypeLabels, DocumentType } from '@/features/shipment/types/documentType';

@Component
export default class QuickActionItem extends Vue {
  @Prop({ required: true }) document!: {
    id: string | number;
    name: string;
    documentType?: string;
  };

  @Prop({ default: false }) isAdded!: boolean;

  @Prop({ default: false }) isAutoGenerated!: boolean;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: false }) isDisabled!: boolean;

  get buttonLabel(): string {
    return `${this.$t('buttons.add')}: ${this.document.name}`;
  }

  get documentTypeLabel(): string {
    const dt = this.document.documentType;
    if (!dt || dt === 'NotSet') return '';
    return DocumentTypeLabels[dt as DocumentType] || dt;
  }
}
